<template>
    <div class="desktop-main" v-cloak>
        <div
            class="desktop-bg"
            style="background-image: url('https://picsum.photos/1920/1200');"
        ></div>
        <!-- <div
            class="desktop-bg"
            style="background-image: url('https://api.dujin.org/pic/');"
        ></div> -->
        <div class="background-overlay"></div>
        <div class="desktop-view">
            <!-- <hq-BulletChat
                ref="hqBulletChat"
                @bullectchat="localLookSet"
                :barrageLists="barrageLists"
                v-show="list[6].value"
            /> -->
            <!-- 顶部模块 -->
            <div class="desktop-header">
                <el-row>
                    <!--头部左侧links模块  -->
                    <el-col :span="14">
                        <div class="project">
                            <div class="normal">
                                <div
                                    class="normal-bottom"
                                    @click="normalVisibleClick"
                                >
                                    常用工具
                                    <i
                                        class="el-icon-caret-bottom"
                                        v-if="normalVisible"
                                    ></i>
                                    <i class="el-icon-caret-top" v-else></i>
                                </div>
                                <div class="input-ser" v-if="list[0].value">
                                    <input
                                        type="text"
                                        placeholder="搜你想找的东西"
                                        @keyup.enter="togoBaidu"
                                        v-model="search"
                                    />
                                    <i class="el-icon-search"></i>
                                </div>
                                <!-- <div
                                    class="input-sers"
                                    type="text"
                                    style="margin-left: 20px;"
                                    v-if="list[6].value"
                                >
                                    <input
                                        type="text"
                                        placeholder="匿名发布，请输入弹幕"
                                        v-model="searchs"
                                        maxlength="50"
                                        @keyup.enter="bulletChat(searchs)"
                                    />
                                    <i class="el-icon-chat-line-round"></i>
                                    <span
                                        class="el-icon-searchs"
                                        @click="bulletChat(searchs)"
                                        >提交</span
                                    >
                                </div> -->
                            </div>
                            <div class="tree-project" v-if="!normalVisible">
                                <el-tree
                                    :data="setUpList"
                                    :props="defaultProps"
                                    @node-click="handleNodeClick"
                                    node-key="id"
                                    accordion
                                >
                                    <span
                                        class="custom-tree-node"
                                        slot-scope="{ node, data }"
                                    >
                                        <span>
                                            <i :class="node.icon"></i
                                            >{{ node.label }}
                                        </span>
                                    </span>
                                </el-tree>
                            </div>
                        </div>
                    </el-col>
                    <!-- 头部右侧图标模块-->
                    <el-col :span="10">
                        <div class="d-items">
                            <ul>
                                <li
                                    v-if="list[2].value"
                                    @click="onloadMessageList"
                                >
                                    <img
                                        src="../assets/image/message.png"
                                        alt
                                    />
                                    <div class="messageNum">消息</div>
                                    <span
                                        class="messageNum-style"
                                        v-if="messageNum != 0"
                                        >{{ messageNum }}</span
                                    >
                                </li>
                                <li @click="getlinks" v-if="list[1].value">
                                    <img src="../assets/image/mark.png" alt />
                                    <div>书签</div>
                                </li>
                                <!-- <li @click="getFood(0)">
                                    <img src="../assets/image/food.png" alt />
                                    <div>划餐</div>
                                </li> -->
                                <li v-if="isAdmin == 1" @click="goBackSystem">
                                    <img src="../assets/image/home.png" alt />
                                    <div class="messageNum">后台</div>
                                </li>
                            </ul>
                        </div>
                    </el-col>
                </el-row>
                <!-- 弹出画餐 -->
                <div class="foot">
                    <el-dialog
                        title="食堂信息"
                        :visible.sync="foodInfo.foodVisible"
                        width="1000px"
                        :modal="true"
                        :modal-append-to-body="false"
                        center
                    >
                        <div class="time-bre">
                            <span>早</span>
                            <span>中</span>
                            <span>晚</span>
                        </div>
                        <div class="time-week">
                            <span
                                v-for="(item, index) in foodInfo.weekTimeArr"
                                :key="index"
                                >{{ item }}</span
                            >
                        </div>
                        <el-table
                            :data="foodInfo.tableData"
                            style="
                                width: 100%;
                                padding-left: 50px;
                                height: 445px;
                            "
                            v-loading="dishesLoading"
                        >
                            <el-table-column
                                :width="120"
                                label="周一"
                                label-class-name="label-calss"
                            >
                                <template class="foot-lis" slot-scope="scope">
                                    <div
                                        :class="{
                                            'bre-icon-sele': true,
                                            prohibit:
                                                scope.row[0].check == -1 ||
                                                scope.row[0].check == -2,
                                        }"
                                        @click="
                                            foodSele(
                                                scope.row[0].check,
                                                scope.row[0].id,
                                                scope.row[0].type
                                            )
                                        "
                                    >
                                        <div class="bre-food">
                                            <span
                                                v-for="(item, index) in scope
                                                    .row[0].food"
                                                :key="index"
                                                >{{ item }}</span
                                            >
                                        </div>
                                        <i class="icon">
                                            <img
                                                src="../assets/image/bre-time-out.png"
                                                v-if="
                                                    scope.row[0].check == -1 &&
                                                    scope.row[0].food != ''
                                                "
                                                alt
                                            />
                                            <img
                                                src="../assets/image/bre-sele.png"
                                                v-if="scope.row[0].check == 1"
                                                alt
                                            />
                                        </i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :width="120"
                                label="周二"
                                label-class-name="label-calss"
                            >
                                <template class="food-lis" slot-scope="scope">
                                    <div
                                        :class="{
                                            'bre-icon-sele': true,
                                            prohibit:
                                                scope.row[1].check == -1 ||
                                                scope.row[1].check == -2,
                                        }"
                                        @click="
                                            foodSele(
                                                scope.row[1].check,
                                                scope.row[1].id,
                                                scope.row[1].type
                                            )
                                        "
                                    >
                                        <div class="bre-food">
                                            <span
                                                v-for="(item, index) in scope
                                                    .row[1].food"
                                                :key="index"
                                                >{{ item }}</span
                                            >
                                        </div>
                                        <i class="icon">
                                            <img
                                                src="../assets/image/bre-time-out.png"
                                                v-if="
                                                    scope.row[1].check == -1 &&
                                                    scope.row[1].food != ''
                                                "
                                                alt
                                            />
                                            <img
                                                src="../assets/image/bre-sele.png"
                                                v-if="scope.row[1].check == 1"
                                                alt
                                            />
                                        </i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :width="120"
                                label="周三"
                                label-class-name="label-calss"
                            >
                                <template class="food-lis" slot-scope="scope">
                                    <div
                                        :class="{
                                            'bre-icon-sele': true,
                                            prohibit:
                                                scope.row[2].check == -1 ||
                                                scope.row[2].check == -2,
                                        }"
                                        @click="
                                            foodSele(
                                                scope.row[2].check,
                                                scope.row[2].id,
                                                scope.row[2].type
                                            )
                                        "
                                    >
                                        <div class="bre-food">
                                            <span
                                                v-for="(item, index) in scope
                                                    .row[2].food"
                                                :key="index"
                                                >{{ item }}</span
                                            >
                                        </div>
                                        <i class="icon">
                                            <img
                                                src="../assets/image/bre-time-out.png"
                                                v-if="
                                                    scope.row[2].check == -1 &&
                                                    scope.row[2].food != ''
                                                "
                                                alt
                                            />
                                            <img
                                                src="../assets/image/bre-sele.png"
                                                v-if="scope.row[2].check == 1"
                                                alt
                                            />
                                        </i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :width="120"
                                label="周四"
                                label-class-name="label-calss"
                            >
                                <template class="food-lis" slot-scope="scope">
                                    <div
                                        :class="{
                                            'bre-icon-sele': true,
                                            prohibit:
                                                scope.row[3].check == -1 ||
                                                scope.row[3].check == -2,
                                        }"
                                        @click="
                                            foodSele(
                                                scope.row[3].check,
                                                scope.row[3].id,
                                                scope.row[3].type
                                            )
                                        "
                                    >
                                        <div class="bre-food">
                                            <span
                                                v-for="(item, index) in scope
                                                    .row[3].food"
                                                :key="index"
                                                >{{ item }}</span
                                            >
                                        </div>
                                        <i class="icon">
                                            <img
                                                src="../assets/image/bre-time-out.png"
                                                v-if="
                                                    scope.row[3].check == -1 &&
                                                    scope.row[3].food != ''
                                                "
                                                alt
                                            />
                                            <img
                                                src="../assets/image/bre-sele.png"
                                                v-if="scope.row[3].check == 1"
                                                alt
                                            />
                                        </i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :width="120"
                                label="周五"
                                label-class-name="label-calss"
                            >
                                <template class="food-lis" slot-scope="scope">
                                    <div
                                        :class="{
                                            'bre-icon-sele': true,
                                            prohibit:
                                                scope.row[4].check == -1 ||
                                                scope.row[4].check == -2,
                                        }"
                                        @click="
                                            foodSele(
                                                scope.row[4].check,
                                                scope.row[4].id,
                                                scope.row[4].type
                                            )
                                        "
                                    >
                                        <div class="bre-food">
                                            <span
                                                v-for="(item, index) in scope
                                                    .row[4].food"
                                                :key="index"
                                                >{{ item }}</span
                                            >
                                        </div>
                                        <i class="icon">
                                            <img
                                                src="../assets/image/bre-time-out.png"
                                                v-if="
                                                    scope.row[4].check == -1 &&
                                                    scope.row[4].food != ''
                                                "
                                                alt
                                            />
                                            <img
                                                src="../assets/image/bre-sele.png"
                                                v-if="scope.row[4].check == 1"
                                                alt
                                            />
                                        </i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :width="120"
                                label="周六"
                                label-class-name="label-endday"
                            >
                                <template class="food-lis" slot-scope="scope">
                                    <div
                                        :class="{
                                            'bre-icon-sele': true,
                                            prohibit:
                                                scope.row[5].check == -1 ||
                                                scope.row[5].check == -2,
                                        }"
                                        @click="
                                            foodSele(
                                                scope.row[5].check,
                                                scope.row[5].id,
                                                scope.row[5].type
                                            )
                                        "
                                    >
                                        <div class="bre-food">
                                            <span
                                                v-for="(item, index) in scope
                                                    .row[5].food"
                                                :key="index"
                                                >{{ item }}</span
                                            >
                                        </div>
                                        <i class="icon">
                                            <img
                                                src="../assets/image/bre-time-out.png"
                                                v-if="
                                                    scope.row[5].check == -1 &&
                                                    scope.row[6].food != ''
                                                "
                                                alt
                                            />
                                            <img
                                                src="../assets/image/bre-sele.png"
                                                v-if="scope.row[5].check == 1"
                                                alt
                                            />
                                        </i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :width="120"
                                label="周日"
                                label-class-name="label-endday"
                            >
                                <template class="food-lis" slot-scope="scope">
                                    <div
                                        :class="{
                                            'bre-icon-sele': true,
                                            prohibit:
                                                scope.row[6].check == -1 ||
                                                scope.row[6].check == -2,
                                        }"
                                        @click="
                                            foodSele(
                                                scope.row[6].check,
                                                scope.row[6].id,
                                                scope.row[6].type
                                            )
                                        "
                                    >
                                        <div class="bre-food">
                                            <span
                                                v-for="(item, index) in scope
                                                    .row[6].food"
                                                :key="index"
                                                >{{ item }}</span
                                            >
                                        </div>
                                        <i class="icon">
                                            <img
                                                src="../assets/image/bre-time-out.png"
                                                v-if="
                                                    scope.row[6].check == -1 &&
                                                    scope.row[6].food != ''
                                                "
                                                alt
                                            />
                                            <img
                                                src="../assets/image/bre-sele.png"
                                                v-if="scope.row[6].check == 1"
                                                alt
                                            />
                                        </i>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="careful">
                            <h5>注意事项</h5>
                            <p>
                                每日上午11点，打印次日的就餐表，画过餐未就餐，或就餐未画餐罚款10元
                            </p>
                            <!--  -->
                            <el-button
                                class="last-week"
                                type="primary"
                                @click="foodLastWeek"
                                v-if="foodInfo.lastBtnShow"
                                >上一周
                            </el-button>
                            <!--  -->
                            <el-button
                                type="primary"
                                class="next-week"
                                @click="foodNextWeek"
                                :disabled="foodInfo.weekNumber === -1"
                                >下一周
                            </el-button>
                        </div>
                    </el-dialog>
                </div>
                <!-- 弹出书签 -->
                <div class="book-mark">
                    <el-dialog
                        title="书签"
                        :visible.sync="bookmarkVisible"
                        width="900px"
                        :modal="true"
                        :modal-append-to-body="false"
                        center
                    >
                        <div class="mark-box">
                            <div
                                class="mark-item"
                                v-for="(item, index) in bookData"
                                :key="index"
                            >
                                <div class="mark-top">{{ item.name }}</div>
                                <div class="mark-main">
                                    <el-tag
                                        v-for="(val, k) in item.bookmark"
                                        :key="k"
                                    >
                                        <a
                                            :href="val.link_address"
                                            _blank
                                            target="_blank"
                                            >{{ val.name }}</a
                                        >
                                    </el-tag>
                                </div>
                            </div>
                        </div>
                        <div class="mark-bottom">
                            <div class="mark-input">
                                <input
                                    type="text"
                                    placeholder="请输入想添加的网址 例:www.baidu.com 百度"
                                    v-model="addWeb"
                                />
                                <span @click="submitLinks">提交</span>
                            </div>
                        </div>
                    </el-dialog>
                </div>
                <!-- 弹出消息 -->
                <div class="message-dialog">
                    <el-dialog
                        :visible.sync="messageVisible"
                        :modal="true"
                        :modal-append-to-body="false"
                        custom-class="message-position"
                        top="0"
                        width="350px"
                        center
                    >
                        <div slot="title" class="header-title">
                            <el-tabs
                                v-model="activeNameMessage"
                                @tab-click="handleClickMessage"
                            >
                                <el-tab-pane label="全部通知" name="all">
                                    <div class="message-main">
                                        <div
                                            class="message-item"
                                            v-for="(value,
                                            key) in messageDataList"
                                            :key="key"
                                        >
                                            <span class="message-time">{{
                                                key
                                            }}</span>
                                            <div
                                                class="time-list"
                                                v-for="(item, index) in value"
                                                :key="index"
                                                @click="
                                                    detailMessage(
                                                        item.id,
                                                        item.type
                                                    )
                                                "
                                            >
                                                <div
                                                    class="detail-top clearfix"
                                                >
                                                    <div class="fl task-img">
                                                        <img
                                                            v-if="
                                                                item.type === 1
                                                            "
                                                            src="../assets/image/msg_notice.png"
                                                            alt
                                                        />
                                                        <img
                                                            v-else-if="
                                                                item.type === 2
                                                            "
                                                            src="../assets/image/msg_task.png"
                                                            alt=""
                                                        />
                                                        <img
                                                            v-else-if="
                                                                item.type === 3
                                                            "
                                                            src="../assets/image/msg_remind.png"
                                                            alt=""
                                                        />
                                                        <img
                                                            v-else-if="
                                                                item.type === 4
                                                            "
                                                            src="../assets/image/msg_notice.png"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div class="fl task-people">
                                                        <p>
                                                            <span
                                                                v-if="
                                                                    item.type ===
                                                                    1
                                                                "
                                                                >新公告</span
                                                            >
                                                            <span
                                                                v-else-if="
                                                                    item.type ===
                                                                    2
                                                                "
                                                                >新通知</span
                                                            >
                                                            <span
                                                                v-else-if="
                                                                    item.type ===
                                                                    3
                                                                "
                                                                >新提醒</span
                                                            >
                                                            <span
                                                                v-else-if="
                                                                    item.type ===
                                                                    4
                                                                "
                                                                >建议反馈</span
                                                            >
                                                            <span
                                                                class="status"
                                                                v-if="
                                                                    item.type ===
                                                                        4 &&
                                                                    item.suggest_status ===
                                                                        0
                                                                "
                                                                >未通过</span
                                                            >
                                                            <span
                                                                class="status"
                                                                v-if="
                                                                    item.type ===
                                                                        4 &&
                                                                    item.suggest_status ===
                                                                        1
                                                                "
                                                                >已通过</span
                                                            >
                                                        </p>
                                                        <p>
                                                            {{
                                                                item.create_date
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="detail-content">
                                                    {{ item.title }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane name="none">
                                    <span slot="label" class="status-label">
                                        未读通知<i
                                            class="status-none"
                                            v-if="messageNum != 0"
                                        ></i
                                    ></span>
                                    <div class="message-main">
                                        <div
                                            class="message-item"
                                            v-for="(item,
                                            index) in unreadMessageList"
                                            :key="index"
                                            @click="
                                                detailMessage(
                                                    item.id,
                                                    item.type
                                                )
                                            "
                                        >
                                            <div class="time-list">
                                                <div
                                                    class="detail-top clearfix"
                                                >
                                                    <div class="fl task-img">
                                                        <img
                                                            v-if="
                                                                item.type === 1
                                                            "
                                                            src="../assets/image/msg_notice.png"
                                                            alt
                                                        />
                                                        <img
                                                            v-else-if="
                                                                item.type === 2
                                                            "
                                                            src="../assets/image/msg_task.png"
                                                            alt=""
                                                        />
                                                        <img
                                                            v-else-if="
                                                                item.type === 3
                                                            "
                                                            src="../assets/image/msg_remind.png"
                                                            alt=""
                                                        />
                                                        <img
                                                            v-else-if="
                                                                item.type === 4
                                                            "
                                                            src="../assets/image/msg_notice.png"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div class="fl task-people">
                                                        <p>
                                                            <span
                                                                v-if="
                                                                    item.type ===
                                                                    1
                                                                "
                                                                >新公告</span
                                                            >
                                                            <span
                                                                v-else-if="
                                                                    item.type ===
                                                                    2
                                                                "
                                                                >新通知</span
                                                            >
                                                            <span
                                                                v-else-if="
                                                                    item.type ===
                                                                    3
                                                                "
                                                                >新提醒</span
                                                            >
                                                            <span
                                                                v-else-if="
                                                                    item.type ===
                                                                    4
                                                                "
                                                                >建议反馈</span
                                                            >
                                                            <span
                                                                class="status"
                                                                v-if="
                                                                    item.type ===
                                                                        4 &&
                                                                    item.suggest_status ===
                                                                        0
                                                                "
                                                                >未通过</span
                                                            >
                                                            <span
                                                                class="status"
                                                                v-if="
                                                                    item.type ===
                                                                        4 &&
                                                                    item.suggest_status ===
                                                                        1
                                                                "
                                                                >已通过</span
                                                            >
                                                        </p>
                                                        <p>
                                                            {{
                                                                item.create_date
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="detail-content">
                                                    {{ item.title }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </el-dialog>
                </div>
                <!--  弹出建议内容-->
                <div class="suggest-content">
                    <el-dialog
                        :visible.sync="suggestDialogVisible"
                        :modal="true"
                        :title="suggestDetailList.title"
                        :modal-append-to-body="false"
                        center
                        width="800px"
                    >
                        <div
                            class="detail-main"
                            v-if="messageType === 1"
                            v-loading="suggestLoading"
                        >
                            <div class="problem-style">
                                <div class="style-text">问题</div>
                                <div class="problem-style-content">
                                    {{ suggestDetailList.content }}
                                </div>
                                <div class="problem-style-time">
                                    提交时间：
                                    {{ suggestDetailList.create_time }}
                                </div>
                            </div>
                            <div class="feedback-style">
                                <div class="style-text">反馈</div>
                                <div class="problem-style-content">
                                    {{ suggestDetailList.solve_content }}
                                </div>
                                <div class="problem-style-status">
                                    状态：
                                    {{
                                        suggestDetailList.result === 1
                                            ? "已通过"
                                            : "未通过"
                                    }}
                                </div>
                            </div>
                        </div>
                        <div v-else v-loading="suggestLoading">
                            <div
                                class="hot-main"
                                v-html="suggestDetailList.content"
                            >
                                {{ this.suggestDetailList.content }}
                            </div>
                            <div class="filePath-style">
                                <div v-if="suggestFileList">附件下载：</div>
                                <div v-for="item in suggestFileList">
                                    <a :href="item.fullPath">{{
                                        item.showName
                                    }}</a>
                                </div>
                            </div>
                        </div>
                    </el-dialog>
                </div>
                <!-- 弹出热点/公告面板 -->
                <div class="message-dialog">
                    <el-dialog
                        :visible.sync="hotMessageVisible"
                        :modal="true"
                        title="新闻动态"
                        :modal-append-to-body="false"
                        custom-class="message-position"
                        top="0"
                        width="350px"
                        center
                    >
                        <div class="line"></div>
                        <div class="hot-message-main">
                            <ul>
                                <li
                                    v-for="(item, index) in hot.pageNewsList"
                                    :key="index"
                                    @click="hotItemVisible(item.id)"
                                    class="overflow-title"
                                >
                                    <span class="label-style">{{
                                        item.label
                                    }}</span>
                                    <h4>{{ item.title }}</h4>
                                    <div class="flow-style">
                                        {{ item.excerpt }}
                                    </div>
                                </li>
                            </ul>
                            <div
                                class="more-new"
                                @click="moreNews"
                                v-if="lookMore"
                            >
                                查看更多
                            </div>
                        </div>
                    </el-dialog>
                </div>
                <!-- 弹出热点新闻详细 -->
                <div class="hot-dialog">
                    <el-dialog
                        :visible.sync="hot.hotVisible"
                        append-to-body
                        width="1000px"
                        v-model="hot.articleDetails"
                        :close-on-click-moda="false"
                        center
                    >
                        <div slot="title" class="hot-title">
                            {{ hot.articleDetails.title }}
                        </div>
                        <div
                            class="hot-main"
                            v-html="hot.articleDetails.content"
                        >
                            {{ hot.articleDetails.content }}
                        </div>
                    </el-dialog>
                </div>
            </div>
            <!-- 事件模块 -->
            <div class="d-center">
                <div class="default-clock">
                    <div class="time">{{ hour }}:{{ minutes }}</div>
                </div>
                <div class="message">
                    {{ timeMessage }} !&nbsp;&nbsp;
                    <span class="d-name">{{ name }}</span>
                </div>
            </div>
            <!-- 待办事项 -->
            <!--<div class="center-below" v-if="list[3].value">
                <div class="prompt">
                    <p v-if="todaySeen">
                        <el-checkbox
                            v-model="todayCheck"
                            :class="todayCheck ? 'selectToDo-style' : ''"
                            >{{ today }}</el-checkbox
                        >
                        <i
                            class="el-icon-close iconfont"
                            @click="closeTodayDo"
                        ></i>
                    </p>
                    <input
                        v-else
                        type="text"
                        placeholder="今天想搞定什么"
                        v-model="today"
                        @keyup.enter="todayDoing"
                    />
                </div>
            </div> -->
            <!--底部模块 -->
            <div class="d-footer">
                <!-- 设置模块 -->
                <div class="f-left">
                    <el-popover
                        :visible-arrow="false"
                        placement="top"
                        width="700"
                        popper-class="tab-bottom"
                        trigger="manual"
                        :offset="40"
                        transition="el-zoom-in-bottom"
                        v-model="setUpVisible"
                    >
                        <div class="userInFo">
                            <div class="userImg">
                                <img :src="dingdingImg" alt />
                            </div>
                            <i>{{ name }}</i>
                            <a @click="handleLogout">
                                <img src="../assets/image/sign-out.png" alt />
                            </a>
                        </div>
                        <el-tabs
                            tab-position="left"
                            v-model="tabActiveName"
                            @tab-click="handleClick"
                        >
                            <el-tab-pane
                                label="界面"
                                name="interface"
                                class="main-look"
                            >
                                <span slot="label">
                                    <img
                                        src="../assets/image/interface.png"
                                        alt
                                    />界面
                                </span>
                                <div class="title">
                                    <h4>界面</h4>
                                    <span>是否在主界面上展开</span>
                                </div>
                                <ul class="link-main">
                                    <template v-for="(item, index) in list">
                                        <li :key="index" v-if="item.status">
                                            {{ item.name }}
                                            <div>
                                                <el-switch
                                                    v-model="item.value"
                                                    active-color="#13ce66"
                                                    inactive-color="#a8b1b6"
                                                    @change="switchChange(item.id)"
                                                ></el-switch>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </el-tab-pane>
                            <el-tab-pane
                                label="新闻动态"
                                class="hot"
                                name="journalism"
                            >
                                <span slot="label">
                                    <img
                                        src="../assets/image/notice.png"
                                        alt
                                    />新闻动态
                                </span>
                                <div class="title">
                                    <h4>新闻动态</h4>
                                    <span>最快的信息，最热的热门</span>
                                </div>
                                <div class="content">
                                    <ul>
                                        <li
                                            @click="hotItemVisible(item.id)"
                                            v-for="(item,
                                            index) in hot.journalismList"
                                            :key="index"
                                        >
                                            <h5>{{ item.title }}</h5>
                                            <div class="text">
                                                {{ item.excerpt }}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    class="more"
                                    @click="viewAll"
                                    v-if="lookAllNews"
                                >
                                    查看全部
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="帮助" name="help" class="help">
                                <span slot="label">
                                    <img
                                        src="../assets/image/help.png"
                                        alt
                                    />帮助
                                </span>
                                <div class="title">
                                    <h4>帮助</h4>
                                    <span>工具使用当中的常见问题</span>
                                </div>
                                <div class="help-item">
                                    <el-collapse>
                                        <el-collapse-item
                                            v-for="(item,
                                            index) in hot.journalismList"
                                            :key="index"
                                            :title="item.title"
                                        >
                                            <div v-html="item.content">
                                                {{ item.content }}
                                            </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                </div>
                            </el-tab-pane>
                            <!-- <el-tab-pane
                                label="建议"
                                name="proposal"
                                class="proposal"
                            >
                                <span slot="label">
                                    <img
                                        src="../assets/image/proposal.png"
                                        alt
                                    />建议
                                </span>
                                <div class="title">
                                    <h4>匿名信箱</h4>
                                    <span>你的每一个建议我们都会认真聆听</span>
                                </div>
                                <div
                                    class="proposal-main"
                                    v-if="suggestType === 1"
                                >
                                    <div class="text-area">
                                        <textarea
                                            name="sug"
                                            cols="60"
                                            rows="14"
                                            placeholder="请输入文字"
                                            maxlength="300"
                                            v-model="suggestValue"
                                        ></textarea>
                                    </div>
                                    <div class="btn">
                                        <button
                                            class="proposal-btn"
                                            @click="suggestBtn"
                                        >
                                            提交
                                        </button>
                                    </div>
                                </div>
                                <div class="proposal-ok" v-else>
                                    <div class="proposal-img">
                                        <img src="../assets/image/ok.png" alt />
                                    </div>
                                    <p>提交成功</p>
                                    <p @click="() => (this.suggestType = 1)">
                                        继续填写
                                    </p>
                                </div>
                            </el-tab-pane> -->
                            <el-tab-pane
                                label="关于我们"
                                name="we"
                                class="self-we"
                            >
                                <span slot="label">
                                    <img
                                        src="../assets/image/about-us.png"
                                        alt
                                    />关于我们
                                </span>
                                <div class="title">
                                    <h4>关于我们</h4>
                                    <span>欢迎加入佳冠大家庭</span>
                                </div>
                                <div class="content">
                                    <ul>
                                        <li
                                            @click="hotItemVisible(item.id)"
                                            v-for="(item,
                                            index) in hot.journalismList"
                                            :key="index"
                                        >
                                            <h5>{{ item.title }}</h5>
                                            <div class="text">
                                                {{ item.excerpt }}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                        <div class="setting" slot="reference" @click="treeSet">
                            <img
                                src="../assets/image/set-up.png"
                                alt
                            />&nbsp;&nbsp; 设置
                        </div>
                    </el-popover>
                </div>
                <div class="f-lefts">
                    <el-popover
                        :visible-arrow="false"
                        placement="top"
                        width="500"
                        popper-class="tab-bottom"
                        trigger="manual"
                        :offset="40"
                        transition="el-zoom-in-bottom"
                        v-model="setUpVisibles"
                    >
                       <div class="proposal">
                            <div class="title">
                                <h4>匿名信箱</h4>
                                <span>你的每一个建议我们都会认真聆听</span>
                            </div>
                            <div
                                class="proposal-main"
                                v-if="suggestType === 1"
                            >
                                <div class="text-area">
                                    <el-input
                                        name="sug"
                                        style="width:100%"
                                        type="textarea"
                                        :rows="12"
                                        maxlength="300"
                                        placeholder="请输入文字"
                                        v-model="suggestValue">
                                    </el-input>
                                    <!-- <textarea
                                        name="sug"
                                        cols="60"
                                        rows="17"
                                        placeholder="请输入文字"
                                        maxlength="300"
                                        v-model="suggestValue"
                                    ></textarea> -->
                                </div>
                                <div class="btn">
                                    <button
                                        class="proposal-btn"
                                        @click="suggestBtn"
                                    >
                                        提交
                                    </button>
                                </div>
                            </div>
                            <div class="proposal-ok" v-else>
                                <div class="proposal-img">
                                    <img src="../assets/image/ok.png" alt />
                                </div>
                                <p>提交成功</p>
                                <p @click="() => (this.suggestType = 1)">
                                    继续填写
                                </p>
                            </div>
                       </div>
                        <div class="setting" style="height: 40px; line-height: 40px;" slot="reference" @click="treeSets">
                            <img
                                src="../assets/image/proposal.png"
                                alt
                            />&nbsp;&nbsp; 员工建议</div>
                    </el-popover>
                </div>
                <div
                    class="f-middle"
                    v-bind:class="list[4].value == false ? 'none' : ''"
                >
                    {{ dayQuotation }}
                </div>
                <!--TODO模块 -->
                <!-- <div class="f-right" v-if="list[5].value">
                    <div
                        class="right-bottom"
                        v-if="towershow"
                        v-show="setUpShow"
                        transition="el-zoom-in-bottom"
                    >
                        <el-tabs
                            v-model="activeName"
                            type="card"
                            @tab-click="towerHandleClick"
                            v-loading="tabsLoading"
                            element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="transparent"
                        >
                            <el-tab-pane label="待完成" name="first">
                                <div class="el-box">
                                    <div
                                        class="el-box-item"
                                        v-for="item in towerNotDoList"
                                        :key="item.id"
                                    >
                                        <el-checkbox
                                            class="check-todo"
                                            @change="
                                                (checked) => clickTask(item.id)
                                            "
                                        ></el-checkbox>
                                        <span
                                            class="detail-task"
                                            @click="detailTask(item.id)"
                                            >{{ item.attributes.content }}</span
                                        >
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="已完成" name="second">
                                <div class="el-box">
                                    <div
                                        class="el-box-item check-todo-done"
                                        v-for="item in doneTaskList"
                                        :key="item.id"
                                    >
                                        <el-checkbox
                                            class="check-todo"
                                            @change="
                                                (checked) => openTask(item.id)
                                            "
                                            :checked="true"
                                        ></el-checkbox>
                                        <span
                                            class="detail-task"
                                            @click="detailTask(item.id)"
                                            >{{ item.attributes.content }}</span
                                        >
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                        <div class="group-sele">
                            <div class="fl" @click="selectGroupDialog">
                                <img src="../assets/image/switch.png" alt="" />
                                切换团队
                            </div>
                            <div class="fr" @click="administrationTask">
                                管理任务
                                <i class="el-icon-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                    <div
                        class="right-bottom"
                        v-else
                        v-show="setUpShow"
                        transition="el-zoom-in-bottom"
                    >
                        <p>使用此功能需进行授权：</p>
                        <p>获取tower数据</p>
                        <span
                            class="grant-authorization"
                            @click="towerAuthorization"
                            >前往授权</span
                        >
                    </div>
                    <div class="setting-todo" @click="setUpShowToDo">Todo</div>
                </div> -->
                <div class="f-right" v-if="list[5].value">
                    <div
                        class="right-bottom"
                        v-show="setUpShow"
                        transition="el-zoom-in-bottom"
                    >
                        <hqTodo />
                        <!-- <p>使用此功能需进行授权：</p>
                        <p>获取tower数据</p>
                        <span
                            class="grant-authorization"
                            @click="towerAuthorization"
                            >前往授权</span
                        > -->
                    </div>
                    <div class="setting-todo" @click="setUpShowToDo">工作计划</div>
                    <!-- <div class="setting-todo" @click="setUpShow = !setUpShow">
                        Todo
                    </div> -->
                </div>
            </div>
            <!-- 弹出团队切换 -->
            <div class="group">
                <el-dialog
                    title="选择 tower 团队"
                    :visible.sync="groupDialogVisible"
                    width="300px"
                    :modal="true"
                    :modal-append-to-body="false"
                >
                    <div class="group-main">
                        <div
                            class="group-item"
                            v-for="(item, index) in towerGruop"
                            :key="index"
                            :class="
                                towerGroupSele === index
                                    ? 'tower-group-active'
                                    : ''
                            "
                            @click="choiceGroup(item.id)"
                        >
                            {{ item.attributes.name }}
                        </div>
                    </div>
                </el-dialog>
            </div>
            <!-- 弹出管理任务dialog -->
            <div class="Team-task">
                <el-dialog
                    :visible.sync="TeamDialogVisible"
                    :modal="true"
                    width="1140px"
                    :modal-append-to-body="false"
                >
                    <iframe
                        src="https://tower.im/teams/53bf417c880d3ae34798e1338f51d9be/projects/"
                        width="100%"
                        height="640"
                        frameborder="0"
                    ></iframe>
                </el-dialog>
            </div>
            <div class="taskDetail">
                <!-- 弹出详情任务dialog -->
                <el-dialog
                    :visible.sync="detailTaskVisible"
                    :modal="true"
                    width="800px"
                    :title="towerDetailTask.content"
                    :modal-append-to-body="false"
                    custom-class="taskDetail-dialog"
                >
                    <div class="title-h">
                        创建人：<span>{{ towerDetailTask.creator }}</span>
                    </div>
                    <div class="title-h">
                        创建时间：<span>{{ towerDetailTask.created_at }}</span>
                    </div>
                    <div class="title-h link" v-if="towerDetailTask.due_at">
                        截止时间：<span>{{ towerDetailTask.due_at }}</span>
                    </div>
                    <div class="title-h">任务描述：</div>
                    <div class="detail" v-html="towerDetailTask.desc">
                        {{ towerDetailTask.desc }}
                    </div>
                    <img src="" alt="" style="width: 20px;" />
                    <div class="title-h" v-if="towerDetailTask.check_items">
                        检查项目：
                    </div>
                    <div
                        class="detail-style"
                        v-if="towerDetailTask.check_items"
                        v-for="(item, index) in towerDetailTask.check_items"
                        :key="index"
                    >
                        - {{ item }}
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import hqTodo from "@/components/todo";
import axiosApi from "axios";
const moment = require("moment");
const Push = require("push.js");
export default {
    components: { hqTodo },
    name: "detailed",
    data() {
        return {
            barrageLists: [],
            searchs: "",
            name: localStorage.getItem("name")
                ? localStorage.getItem("name")
                : "未知",
            search: "", //搜索内容
            normalVisible: false, //控制常用工具的限制影藏
            setUpData: [], //工具栏树状控件测试
            isAdmin: "", //是否拥有后台的访问权限
            defaultProps: {
                children: "children",
                label: "name",
                className: "second-level",
            }, //工具栏树状控件测试
            setUpList: [], //工具设置是否显示
            messageVisible: false, //消息面板
            activeNameMessage: "all",
            messageDataList: {},
            hotMessageVisible: false, //热点公告面板
            foodInfo: {
                foodVisible: false, //画餐面板
                weekNumber: "", //获取是否有下一周
                weekTimeArr: [], //一周的时间
                tableData: [], //画餐数据
                lastBtnShow: false,
                weekLast: "",
            }, //画餐相关的数据
            towerGroupSele: "",
            bookmarkVisible: false, //书签面板
            bookData: {}, //书签数据
            addWeb: "", //书签添加框
            tabActiveName: "interface", //设置tab默认选中第一个
            hour: "", //当前小时
            minutes: "", //当前分钟
            timeMessage: "", // 当前所属时间段
            today: "", //今天要做的事情
            todaySeen: localStorage.getItem("todaySeen")
                ? localStorage.getItem("todaySeen")
                : 0,
            todayCheck: false,
            hot: {
                hotVisible: false, //热点新闻面板
                journalismList: [], //新闻的数据
                pageNewsList: [],
                page: 1,
                pageNum: 0,
                articleDetails: "",
                total: "",
            },
            elChecked: true,
            messageNum: 0, //消息未读数量
            openOnlySet: false,
            messageTimer: "", //消息定时器的标识
            suggestLoading: false,
            lookMore: false, //查看更多新闻
            lookAllNews: false, //查看全部新闻
            list: [], //界面设置配置
            suggestValue: "", //建议内容
            suggestType: 1, //设置建议部分
            suggestDialogVisible: false, //建议状态dialog
            suggestDetailList: [], //建议详细内容
            unreadMessageList: [], //未读消息列表
            messageType: 0, //消息读取的类型
            visible: false, //TODO分配是否显示
            setUpShow: true,
            dayQuotation: "", //每日语录
            checkChoice: [], //测试级联框
            setUpVisible: false,
            setUpVisibles: false,
            towershow: true, // towerToken
            activeName: "first", // todo切换
            groupDialogVisible: false, //切换团队dialog
            TeamDialogVisible: false,
            dishesLoading: false,
            towerGruop: [], // tower团队的数据
            towerNotDoList: [], //tower 未完成任务
            doneTaskList: [], // tower已完成任务
            detailTaskVisible: false, //任务详细
            towerDetailTask: {}, //任务详细的数据
            tabsLoading: false,
            dingdingImg: "",
            suggestFileList: [],
        };
    },
    created() {
        this.localLookSet();
    },
    mounted() {
        // 获取当前时间
        this.getNowTime();
        // 获取工具列表
        this.getSetUpList();
        // 获取今天要做的事
        this.timeRefresh();
        // 一秒刷新时间
        this.getTodayDoing();
        // 请求语录
        this.dayQuotations();
        this.localTowerTokenType();
        // 轮训获取未读消息提醒
        this.readMessage();
    },
    methods: {
        goBackSystem() {
            let token = localStorage.getItem("token").replace(/Bearer /g, "");
            // console.log(token);
            // window.open(
            //     "http://192.168.3.146:8000/admin/user/login?token=" + token
            // ); //本地地址
            // window.open(
            //     "http://oa.test.jgyljt.com/admin/user/login?token=" + token
            // ); //老测试地址
            // window.open(
            //     "http://desktop-test.jgyljt.com/admin/user/login?token=" + token
            // ); //新测试地址
            window.open(
                "https://desktop.jgyljt.com/admin/user/login?token=" + token
            ); //正式地址
        },
        normalVisibleClick() {
            this.normalVisible = !this.normalVisible;
            this.normalVisible === false && this.setUpVisible === true
                ? (this.setUpVisible = false)
                : "";
        },
        treeSet() {
            this.setUpVisible = !this.setUpVisible;
            if (this.setUpVisible) {
                this.setUpVisibles = false
                this.normalVisible = true
            } else {
                this.setUpVisibles = false
                this.normalVisible = false
            }
            // this.normalVisible === false && this.setUpVisible === true
            //     ? (this.normalVisible = true)
            //     : (this.normalVisible = false);
            if (
                this.setUpVisible === true &&
                !localStorage.getItem("dingdingImg")
            ) {
                this.$http({
                    method: "post",
                    url: "/api/v1/auth/getUserAvatar",
                })
                    .then((res) => {
                        localStorage.setItem("dingdingImg", res.data.result);
                        this.dingdingImg = res.data.result;
                    })
                    .finally(() => {});
            } else {
                this.dingdingImg =
                    localStorage.getItem("dingdingImg") !== ""
                        ? localStorage.getItem("dingdingImg")
                        : require("../assets/image/login-bg.png");
            }
        },

        treeSets() {
            this.setUpVisibles = !this.setUpVisibles;

            if (this.setUpVisibles) {
                this.setUpVisible = false
                this.normalVisible = true
            } else {
                this.setUpVisible = false
                this.normalVisible = false
            }
        },
        // 请求本地界面配置 登陆成功后设置界面配置本地存储，每次修改后获取储藏修改对应的项
        localLookSet() {
            let setLookInFo = localStorage.getItem("setUpInfo");
            if (!setLookInFo) {
                this.$router.push({ name: "Login" });
            }
            this.list = JSON.parse(setLookInFo);
            // console.log(this.list)
            this.list[5].name = "工作计划";
        },
        // 请求语录
        dayQuotations() {
            this.$http({
                method: "post",
                url: "/api/v1/motto/getRandomMotto",
            })
                .then((data) => {
                    this.dayQuotation = data.data.result;
                })
                .finally(() => {});
        },
        // 获取工具列表
        getSetUpList() {
            this.$http({
                method: "post",
                url: "/api/v1/tool/index",
            })
                .then((data) => {
                    this.setUpList = data.data.result;
                    // this.$refs.hqBulletChat.addToList();
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        // 调用失败token失效
        tokenTimeOut() {
            this.handleInitLoginCheck();
            // localStorage.removeItem('token')
            // clearInterval(this.messageTimer)
            // this.$message.error("需要重新登录授权");
            // setTimeout(()=>{
            //   this.$router.push({path:'/login'});
            // },2000)
        },
        handleInitLoginCheck() {
            let uuid = localStorage.getItem("uuid");
            this.$http({
                method: "post",
                url: "/api/v1/auth/dingLoginCheck",
                data: {
                    code: uuid,
                },
            })
                .then((res) => {
                    localStorage.setItem(
                        "dingdingUserId",
                        res.data.result.ding_user_id
                    ); //钉钉的用户id
                    localStorage.setItem(
                        "expires_in",
                        res.data.result.expires_in
                    );
                    localStorage.setItem("user_id", res.data.result.id);
                    localStorage.setItem("name", res.data.result.name);
                    localStorage.setItem(
                        "token",
                        "Bearer " + res.data.result.token
                    );
                    localStorage.setItem(
                        "is_chose_team",
                        res.data.result.is_chose_team
                    );
                    localStorage.setItem(
                        "is_tower_auth",
                        res.data.result.is_tower_auth
                    );
                    localStorage.setItem("is_admin", res.data.result.is_admin);
                    localStorage.setItem("union_id", res.data.result.union_id);
                    localStorage.setItem("uuid", uuid);
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        // 工具点击跳转
        handleNodeClick(data) {
            if (data.link_address === "http://") {
                return;
            }
            this.$http({
                method: "get",
                url: "/api/v1/auth/getMd5",
            }).then((res) => {
                let userid = localStorage.getItem("dingdingUserId");
                // false有？ true 无问号
                let identification =
                    data.link_address.indexOf("?") === -1 ? "?" : "&";
                if (
                    data.link_address === "http://bdf.jgyljt.com/jgadmin.html"
                ) {
                    let userName = localStorage.getItem("name");
                    window.open(
                        data.link_address +
                            identification +
                            "&uId=" +
                            userName +
                            "|" +
                            userid +
                            "&userid=" +
                            userid +
                            "&t=" +
                            res.data.result.t +
                            "&md5_t=" +
                            res.data.result.md5_t
                    );
                } else {
                    window.open(
                        data.link_address +
                            identification +
                            "userid=" +
                            userid +
                            "&t=" +
                            res.data.result.t +
                            "&md5_t=" +
                            res.data.result.md5_t
                    );
                }
            });
        },
        // 获取书签
        getlinks() {
            this.setUpVisible = false;
            this.bookmarkVisible = true;
            this.$http({
                method: "post",
                url: "/api/v1/bookmark/index",
            }).then((data) => {
                this.bookData = data.data.result;
            });
        },
        // 提交书签申请
        submitLinks() {
            if (this.addWeb) {
                this.$http({
                    method: "post",
                    url: "/api/v1/bookmark/apply",
                    data: {
                        applicant: this.name,
                        content: this.addWeb,
                    },
                })
                    .then((res) => {
                        this.$message.success("提交成功");
                    })
                    .catch((error) => {
                        this.$message.error("提交失败");
                    })
                    .finally(() => {
                        this.bookmarkVisible = false;
                    });
            }
        },
        togoBaidu() {
            window.open("https://www.baidu.com/s?wd=" + this.search);
        },
        // 今天做的事情
        todayDoing() {
            if (!this.today) {
                return;
            }
            this.todayCheck = false;
            let obj = {
                todayTodo: this.today,
                saveTime: moment().format("YYYY-MM-DD"),
            };
            this.todaySeen = 1;
            localStorage.setItem("todaySeen", 1);
            localStorage.setItem("todayTodo", JSON.stringify(obj));
        },
        closeTodayDo() {
            localStorage.removeItem("todaySeen");
            this.todaySeen = 0;
            this.today = "";
            localStorage.removeItem("todayTodo");
        },
        // 获取当前时间
        getNowTime() {
            this.hour = moment().format("HH:mm:ss").split(":")[0];
            this.minutes = moment().format("hh:mm:ss").split(":")[1];
            let hour = new Date().getHours();
            this.timeMessage =
                hour < 9
                    ? "早上好"
                    : hour <= 11
                    ? "上午好"
                    : hour <= 13
                    ? "中午好"
                    : hour < 19
                    ? "下午好"
                    : "晚上好";
        },
        // 获取今天要做的事情
        getTodayDoing() {
            let oldTime = localStorage.getItem("todayTodo")
                ? JSON.parse(localStorage.getItem("todayTodo"))
                : "";
            this.isAdmin = localStorage.getItem("is_admin");
            if (oldTime) {
                let newTime = moment().format("YYYY-MM-DD");
                if (moment(oldTime.saveTime).isBefore(newTime)) {
                    this.today = "";
                } else {
                    this.today = oldTime.todayTodo;
                }
            }
        },
        // 一秒改变一次时间
        timeRefresh() {
            setInterval(() => {
                this.getNowTime();
            }, 1000);
        },
        // 获取画餐数据
        getFood() {
            this.setUpVisible = false;
            this.foodInfo.foodVisible = true;
            this.foodInfo.lastBtnShow = false;
            this.$nextTick(() => {
                this.getWeekFood(0);
            });
        },
        // 获取画餐数据
        getWeekFood(week) {
            this.dishesLoading = true;
            this.$http({
                method: "post",
                url: "/api/v1/dishes/index",
                data: {
                    week: week,
                },
            })
                .then((data) => {
                    // console.log(data);
                    this.foodInfo.weekNumber = data.data.result.week;
                    this.foodInfo.tableData = data.data.result.dishesList;
                    let timeArr = [];
                    this.foodInfo.tableData[0].forEach((item) => {
                        timeArr.push(item.date);
                    });
                    this.foodInfo.weekTimeArr = timeArr;
                })
                .catch((error) => {
                    // console.log(error);
                })
                .finally(() => {
                    this.dishesLoading = false;
                });
        },
        // 画餐选择
        foodSele(seleType, id, type) {
            if (seleType == -1 || seleType == -2) {
                return;
            } else if (seleType == 0) {
                seleType = 1;
            } else if (seleType == 1) {
                seleType = 0;
            }
            this.dishesLoading = true;
            this.$http({
                method: "post",
                url: "/api/v1/dishes/chooseDishes",
                data: {
                    dishesId: id,
                    type,
                    status: seleType,
                },
            })
                .then((res) => {
                    this.foodInfo.tableData.forEach((val, key) => {
                        if (key == type - 1) {
                            val.forEach((v, k) => {
                                if (v.id === id) {
                                    v.check = seleType;
                                }
                            });
                        }
                    });
                })
                .catch((error) => {
                    // console.log(error);
                })
                .finally(() => {
                    this.dishesLoading = false;
                });
        },
        // // 下一周
        foodNextWeek() {
            // 1.获取week周数 + 1
            this.foodInfo.weekLast = this.foodInfo.weekNumber;
            this.foodInfo.lastBtnShow = true;
            this.getWeekFood(this.foodInfo.weekNumber);
        },
        // // 上一周
        foodLastWeek() {
            let num = --this.foodInfo.weekLast;
            this.getWeekFood(num);
            if (num == 0) {
                this.foodInfo.lastBtnShow = false;
                return;
            }
        },
        // 获取新闻动态
        handleClick(tab) {
            if (tab.name === "journalism") {
                this.UnifiedInterface({ page: 1, pageSize: 3, categoryId: 1 });
            } else if (tab.name === "help") {
                this.UnifiedInterface({
                    page: 1,
                    pageSize: 1000,
                    categoryId: 2,
                });
            } else if (tab.name === "we") {
                this.UnifiedInterface({
                    page: 1,
                    pageSize: 100,
                    categoryId: 3,
                });
            }
        },
        // 查看全部新闻
        viewAll() {
            this.setUpVisible = false;
            this.hotMessageVisible = !this.hotMessageVisible;
            this.lookMore = true;
            this.hot.page = 1;
            this.hot.pageNewsList = [];
            this.getPageNews({ page: 1 });
        },
        // 查看更多
        moreNews() {
            const page = ++this.hot.page;
            this.getPageNews({ page: page });
        },
        // 新闻分页
        getPageNews(data) {
            this.$http({
                method: "post",
                url: "/api/v1/articlePost/index",
                data: {
                    page: data.page,
                    pageSize: 10,
                    categoryId: 1,
                },
            })
                .then((data) => {
                    this.hot.pageNewsList = [
                        ...this.hot.pageNewsList,
                        ...data.data.result.list,
                    ];
                    this.hot.num = Math.ceil(data.data.result.total / 10);
                    this.hot.num === this.hot.page
                        ? (this.lookMore = false)
                        : (this.lookMore = true);
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        // 统一获取文章类接口
        UnifiedInterface(data) {
            this.$http({
                method: "post",
                url: "/api/v1/articlePost/index",
                data: {
                    page: data.page,
                    pageSize: data.pageSize,
                    categoryId: data.categoryId,
                },
            })
                .then((res) => {
                    this.hot.journalismList = res.data.result.list;
                    if (data.categoryId === 1) {
                        this.hot.total = res.data.result.total;
                        res.data.result.total > 10
                            ? (this.lookMore = true)
                            : (this.lookMore = false);
                        res.data.result.total > 3
                            ? (this.lookAllNews = true)
                            : (this.lookAllNews = false);
                    }
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        onloadMessageList() {
            this.messageVisible = true;
            this.setUpVisible = false;
            this.getMessage({ page: 1, pageSize: 10 });
        },
        // 消息切换
        handleClickMessage(tab) {
            if (tab.name === "all") {
                this.getMessage({ page: 1, pageSize: 20 });
            } else {
                this.getUnreadMessage(1);
            }
        },
        // 全部获取消息
        getMessage(data) {
            this.$http({
                method: "post",
                url: "/api/v1/message/index",
                data: {
                    page: data.page,
                    pageSize: data.pageSize,
                },
            })
                .then((data) => {
                    this.messageDataList = data.data.result.list;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        // 获取未读消息
        getUnreadMessage(type) {
            this.$http({
                method: "post",
                url: "/api/v1/message/notRead",
            })
                .then((res) => {
                    this.messageNum = res.data.result.length;
                    if (type === 1) {
                        this.unreadMessageList = res.data.result;
                    } else {
                        let oldMessageLength = localStorage.getItem(
                            "messageLength"
                        )
                            ? localStorage.getItem("messageLength")
                            : 0;
                        let newMessageLength = res.data.result.length;
                        let messageStatus =
                            newMessageLength > oldMessageLength ? 1 : 0; // 1：可以推送 0：不可以推送
                        localStorage.setItem("messageStatus", messageStatus); // 初始化
                        localStorage.setItem(
                            "messageLength",
                            res.data.result.length
                        );

                        if (messageStatus == 1) {
                            console.log(Push.Permission.has());
                            if (!Push.Permission.has()) {
                                this.$message.error(
                                    "您当前浏览器无权显示通知，请开启浏览器通知！"
                                );
                                return false;
                            }
                            Push.Permission.DEFAULT;
                            Push.create("你有一条新消息", {
                                body: "佳冠桌面的新消息，注意查收~~~",
                                icon: "",
                                timeout: 10000,
                                onClick: function () {
                                    window.focus();
                                    this.close();
                                },
                            });
                            localStorage.setItem("messageStatus", 0); // 初始化
                        }
                        localStorage.setItem(
                            "messageLength",
                            res.data.result.length
                        );
                    }
                })
                .catch((error) => {
                    error.code === 401
                        ? this.tokenTimeOut()
                        : console.log(error);
                });
        },
        // 消息详情
        detailMessage(id, type) {
            this.suggestDialogVisible = true;
            this.detailSuggest(id, type);
        },
        // 消息建议详情
        detailSuggest(id, type) {
            this.suggestLoading = true;
            type === 4 ? (this.messageType = 1) : (this.messageType = 0);
            this.$http({
                method: "post",
                url: "/api/v1/message/read",
                data: {
                    messageId: id,
                },
            })
                .then((res) => {
                    this.suggestLoading = false;
                    this.suggestDetailList = res.data.result;
                    let pathArr = [];
                    res.data.result.file_path.forEach((item) => {
                        let obj = {};
                        obj.fullPath = item;
                        obj.showName = item.slice(item.lastIndexOf("/") + 1);
                        pathArr.push(obj);
                    });
                    pathArr[0].fullPath != ""
                        ? (this.suggestFileList = pathArr)
                        : (this.suggestFileList = "");
                    this.unreadMessageList.forEach((item, index) => {
                        if (item.id === id) {
                            this.unreadMessageList.splice(index, 1);
                        }
                    });
                })
                .catch((error) => {
                    // console.log(error);
                })
                .finally(() => {
                    this.suggestLoading = false;
                });
        },
        // 控制个人设置popover
        hotItemVisible(id) {
            this.hot.hotVisible = true;
            this.$http({
                method: "post",
                url: "/api/v1/articlePost/detail",
                data: {
                    postId: id,
                },
            })
                .then((data) => {
                    this.hot.articleDetails = data.data.result;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        // 设置界面的控制
        switchChange(id) {
            let setUpInfo = JSON.parse(localStorage.getItem("setUpInfo"));
            setUpInfo.forEach((item) => {
                if (item.id === id) {
                    item.value = !item.value;
                }
            });
            localStorage.setItem("setUpInfo", JSON.stringify(setUpInfo));
        },
        // 建议提交
        suggestBtn() {
            // if (!this.suggestValue) {
            //   this.$message.error("记得输入建议内容哦~~");
            //   return;
            // }
            this.$http({
                method: "post",
                url: "/api/v1/suggest/create",
                data: {
                    content: this.suggestValue,
                    user: this.name,
                },
            })
                .then((data) => {
                    this.$message.success("提交成功");
                    this.suggestValue = "";
                    this.suggestType = 2;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        towerAuthorization() {
            this.getTowerToken();
            let userId = localStorage.getItem("user_id");
            let url =
                "https://tower.im/oauth/authorize?client_id=3edf4aa2e3410529ef86605d6333ddd79800cb9b1b121ed34f9b0634962e8e4d&redirect_uri=" +
                this.baseUrl +
                "/api/v1/auth/towerCallback?user_id=" +
                userId +
                "&response_type=code";
            window.open(
                url,
                "",
                "height=400,width=600,top=200,left=700,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no"
            );
        },
        // 获取tower授权状态和团队的状态
        getTowerToken() {
            let timer = setInterval(() => {
                this.$http({
                    method: "post",
                    url: "/api/v1/tower/getUserTowerStatus",
                })
                    .then((res) => {
                        if (res.data.result.is_tower_auth == 1) {
                            clearInterval(timer);
                            localStorage.setItem(
                                "is_tower_auth",
                                res.data.result.is_tower_auth
                            ); //授权状态
                            // 判断是否选择团队 未选择-》选择团队modal弹出
                            if (res.data.result.is_chose_team == 0) {
                                // 获取个人团队
                                this.getTowerGroup();
                                this.groupDialogVisible = true;
                            } else {
                                this.towershow = true;
                            }
                        }
                    })
                    .catch((error) => {
                        // console.log(error);
                    });
            }, 2000);
            setTimeout(() => {
                clearInterval(timer);
            }, 10000);
        },
        // 点击todo
        setUpShowToDo() {
            this.setUpShow = !this.setUpShow;
            if (
                this.setUpShow == true &&
                localStorage.getItem("is_chose_team") == 1 &&
                localStorage.getItem("is_tower_auth") == 1
            ) {
                this.towerNotDo();
            }
        },
        selectGroupDialog() {
            this.groupDialogVisible = true;
            this.setUpVisible = false;
            this.getTowerGroup();
        },
        // 获取tower团队
        getTowerGroup() {
            this.$http({
                method: "post",
                url: "/api/v1/tower/teams",
            })
                .then((res) => {
                    this.towerGruop = res.data.result;
                    this.towerGruop.forEach((item, index) => {
                        item.id === localStorage.getItem("towerGroupId")
                            ? (this.towerGroupSele = index)
                            : "";
                    });
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        administrationTask() {
            this.TeamDialogVisible = true;
            this.setUpVisible = false;
        },
        // 选择tower团队
        choiceGroup(id) {
            this.$http({
                method: "post",
                url: "/api/v1/tower/chooseTeam",
                data: {
                    teamId: id,
                },
            })
                .then((res) => {
                    this.towershow = true;
                    this.groupDialogVisible = false;
                    if (localStorage.getItem("is_chose_team") == 0) {
                        localStorage.setItem("is_chose_team", 1);
                    }
                    localStorage.setItem("towerGroupId", id);
                    this.towerNotDo();
                    this.towerDone();
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        localTowerTokenType() {
            let towerToken = localStorage.getItem("is_tower_auth");
            towerToken == 0
                ? (this.towershow = false)
                : (this.towershow = true);
        },
        // 任务切换
        towerHandleClick(tab) {
            // console.log(tab.label);
            if (tab.label == "已完成") {
                // 获取已完成
                this.towerDone();
            } else {
                // 获取未完成
                this.towerNotDo();
            }
        },
        // 已完成
        towerDone() {
            this.tabsLoading = true;
            this.$http({
                method: "post",
                url: "/api/v1/tower/completedTodos",
            })
                .then((res) => {
                    this.tabsLoading = false;
                    // 完成的任务
                    this.doneTaskList = res.data.result;
                })
                .catch((error) => {
                    // console.log(error);
                })
                .finally(() => {
                    this.tabsLoading = false;
                });
        },
        // 未完成
        towerNotDo() {
            this.tabsLoading = true;
            this.$http({
                method: "post",
                url: "/api/v1/tower/uncompletedTodos",
            })
                .then((res) => {
                    this.tabsLoading = false;
                    // 未完成的任务
                    this.towerNotDoList = res.data.result;
                })
                .catch((error) => {
                    // console.log(error);
                })
                .finally(() => {
                    this.tabsLoading = false;
                });
        },
        // 完成任务
        clickTask(id) {
            this.$http({
                method: "post",
                url: "/api/v1/tower/completion",
                data: {
                    todoId: id,
                },
            })
                .then((res) => {
                    this.towerNotDo();
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        // 打开任务
        openTask(id) {
            this.$http({
                method: "post",
                url: "/api/v1/tower/notCompletion",
                data: {
                    todoId: id,
                },
            })
                .then((res) => {
                    this.towerDone();
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        // 任务的详细
        detailTask(id) {
            this.$http({
                method: "post",
                url: "/api/v1/tower/todoInfo",
                data: {
                    todoId: id,
                },
            })
                .then((res) => {
                    this.detailTaskVisible = true;
                    this.setUpVisible = false;
                    if (res.data.result.created_at) {
                        res.data.result.created_at = res.data.result.created_at.substr(
                            0,
                            10
                        );
                    }
                    if (res.data.result.due_at) {
                        res.data.result.due_at = res.data.result.due_at.substr(
                            0,
                            10
                        );
                    }
                    this.towerDetailTask = res.data.result;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        // 登录退出
        handleLogout() {
            localStorage.removeItem("token");
            localStorage.removeItem("name");
            localStorage.removeItem("expires_in");
            localStorage.removeItem("dingdingImg");
            localStorage.removeItem("dingdingUserId");
            localStorage.removeItem("union_id");
            localStorage.removeItem("pro__Access-Token");
            clearInterval(this.messageTimer);
            this.$router.push({ path: "/login" });
        },
        readMessage() {
            this.getUnreadMessage(2);
            let timer = setInterval(() => {
                this.getUnreadMessage(2);
            }, 8000);
            this.messageTimer = timer;
        },
        // bulletChat() {
        //     this.$http({
        //         method: "post",
        //         url: "/api/v1/bulletChat/create",
        //         data: {
        //             bullet_chat: this.searchs,
        //         },
        //     })
        //         .then((res) => {
        //             this.barrageLists = [res.data.result];
        //             this.$message({
        //                 message: "发送成功",
        //                 type: "success",
        //             });
        //             this.$nextTick(() => {
        //                 // this.$refs.hqBulletChat.initial();
        //             });
        //         })
        //         .catch((error) => {
        //             // console.log(error);
        //         });
        //     this.searchs = "";
        // },
    },
};
</script>
<style scope>
[v-clock] {
    display: none;
}
.filePath-style a {
    color: #2eabff;
}
.status-label {
    position: relative;
}
.status-none {
    position: absolute;
    top: 0;
    left: 60px;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: red;
}
.todo-show {
    opacity: 0;
}
.tower-group-active {
    background-color: #13c2c2;
    color: #fff;
}
.desktop-main {
    min-height: 100%;
    overflow: hidden;
    margin: 0px;
    padding: 0px;
    z-index: 2;
    /*color:transparent;*/
}

.desktop-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-repeat: no-repeat;
    background-color: transparent;
    background-size: cover;
    background-position: center center;
    z-index: 1;
}

.background-overlay {
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background-image: url(../assets/image/overlay-vignette.png);
    background-size: 100% 100%;
    transition: opacity 0.3s ease-out;
    z-index: 2;
}

.desktop-view {
    position: absolute;
    z-index: 2;
    color: #fff;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
}

.desktop-view ul,
h3 {
    margin: 0px;
    padding: 0px;
}

.desktop-view ul li {
    list-style: none;
}

.desktop-header {
    min-height: 60px;
}

.links {
    text-align: left;
    padding: 20px 0 0 20px;
}

.links .el-dropdown-link {
    color: #fff;
    font-weight: 600;
    font-size: 18px;
    cursor: pointer;
}

.menu {
    background: rgba(15, 15, 15, 0.925);
    border: none;
}

.menu li {
    color: #f2f2f2;
    /* opacity: 0.75; */
}

.menu li:hover {
    color: #f2f2f2;
    background: none;
}

.d-items {
    padding: 15px 20px 0 0;
}

.d-items ul li {
    float: right;
    margin: 0 10px;
    border-radius: 50px;
    width: 80px;
    height: 36px;
    color: #fff;
    line-height: 36px;
    text-align: center;
    font-size: 14px;
}

.d-items ul li img {
    vertical-align: middle;
}

.d-items ul li div {
    margin-left: 4px;
    display: inline-block;
}

.d-items ul li:hover {
    cursor: pointer;
}

.center-below {
    position: absolute;
    width: 60%;
    left: 20%;
    top: 70%;
}

.d-center {
    position: absolute;
    width: 454px;
    left: 50%;
    top: 50%;
    margin: -200px 0 0 -200px;
}

.d-center .default-clock {
    margin-top: -10px;
    display: inline-block;
    position: relative;
}

.time {
    cursor: default;
    font-size: 1200%;
    letter-spacing: -5px;
    font-weight: 500;
}

.message {
    font-size: 34px;
    margin-top: 20px;
}
.prompt input {
    width: 720px;
    height: 36px;
    border: none;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    color: #fff;
    outline: 0;
    font-size: 18px;
    text-align: center;
    border-radius: 4px;
}

.prompt .el-checkbox {
    margin-right: 30px;
    max-width: 80%;
}
.prompt .el-checkbox__label {
    display: inline-block;
    min-height: 40px;
    white-space: normal;
    font-size: 18px;
    vertical-align: top;
}

.prompt .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #fff;
}

.prompt .el-checkbox__inner::after {
    height: 11px;
    left: 8px;
    width: 4px;
}

.prompt .el-checkbox__original {
    width: 40px;
}

.prompt .el-checkbox__inner {
    width: 20px;
    height: 20px;
}

.prompt input::-webkit-input-placeholder {
    color: #fff;
    opacity: 1;
    font-size: 18px;
}

/* 清除浮动的通用类名 */
.clearfix:after,
.clearfix:before {
    content: "";
    display: table;
}

.clearfix:after {
    clear: both;
}

.clearfix {
    *zoom: 1;
}

/* 浮动类名 */
.fl {
    float: left;
}

.fr {
    float: right;
}

p {
    margin: 0;
    padding: 0;
}

.el-popover {
    background: rgba(15, 15, 15, 0.925);
    border: none;
    color: #afafaf;
}

.tab-bottom {
    height: 440px;
    margin-left: 14px;
    border-radius: 16px;
    padding: 0;
    /* top: none!important;
    bottom: 75px; */
}

.tab-bottom .el-tabs .el-tabs__item {
    color: #afafaf;
}

.tab-bottom .el-tabs__item.is-active {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
}

.tab-bottom .el-tabs__header {
    width: 120px;
    padding: 120px 40px 55px 0;
    border-radius: 14px;
    background-color: rgba(0, 0, 0, 0.2);
}

.tab-bottom .el-tabs--left .el-tabs__item.is-left {
    text-align: left;
    padding-left: 10px;
    height: 60px;
}

.tab-bottom .el-tabs--left .el-tabs__nav-scroll {
    height: 320px;
    margin-top: -6px;
}

.tab-bottom .el-tabs--left .el-tabs__nav-wrap.is-left {
    height: 320px;
}

.tab-bottom .el-tabs--left .el-tabs__active-bar.is-left,
.tab-bottom .el-tabs--left .el-tabs__active-bar.is-right,
.tab-bottom .el-tabs--right .el-tabs__active-bar.is-left,
.tab-bottom .el-tabs--right .el-tabs__active-bar.is-right {
    width: 0;
}

.tab-bottom .el-tabs--left .el-tabs__nav-wrap.is-left::after,
.tab-bottom .el-tabs--left .el-tabs__nav-wrap.is-right::after,
.tab-bottom .el-tabs--right .el-tabs__nav-wrap.is-left::after,
.tab-bottom .el-tabs--right .el-tabs__nav-wrap.is-right::after {
    width: 0;
}

.tab-bottom .el-tabs--right .el-tabs__nav-wrap.is-right::after {
    width: 0;
}

.tab-bottom .el-tabs--left .el-tabs__header.is-left {
    height: 265px;
}

/* 顶部常用工具 */
.project {
    position: relative;
    margin: 0 30px;
}

.normal {
    height: 60px;
    cursor: pointer;
    padding-top: 20px;
}

.normal .normal-bottom {
    float: left;
    width: 130px;
    text-align: left;
    padding-top: 4px;
}

.normal .input-ser {
    height: 30px;
    float: left;
    position: relative;
}

.el-menu-demo {
    width: 116px;
}

.project .input-ser input {
    color: #afafaf;
    height: 30px;
    width: 180px;
    line-height: 29px;
    border-radius: 30px;
    padding: 1px 0 1px 45px;
    border: none;
    outline: none;
    background: rgba(0, 0, 0, 0.5);
}

.active {
    color: #409eff;
}

.project .input-ser input::-webkit-input-placeholder {
    color: #ccc!important;
    font-size: 14px;
}
.project .input-sers input::-webkit-input-placeholder {
    color: #ccc;
    font-size: 14px;
}

.project .el-icon-search {
    position: absolute;
    z-index: 999;
    top: 8px;
    left: 13px;
}
.project .el-icon-chat-line-round {
    position: absolute;
    z-index: 999;
    top: 8px;
    left: 13px;
}

/* element-tree 项目列表*/
.project .tree-project {
    position: absolute;
    top: 65px;
    left: 0;
}

.project .tree-project .el-tree {
    height: 570px;
    min-width: 185px;
    color: #afafaf;
    background-color: rgba(15, 15, 15, 0.925);
    border-radius: 4px;
    font-size: 14px;
    padding: 6px 10px;
    overflow: auto;
}

.project .el-tree .el-tree-node .el-tree-node__content {
    background: transparent;
    padding: 3px 10px;
}

.project .el-tree .el-tree-node .el-tree-node__content:hover {
    background: rgba(0, 0, 0, 0.5);
}

/* 画餐弹出 */
.foot .el-dialog__body {
    padding-top: 6px;
}

.foot .el-table td,
.foot .el-table th.is-leaf,
.foot .el-table {
    border-bottom: none;
}

.foot .el-table::before {
    display: none;
}

.foot .el-table__body .el-table__row:nth-child(2) {
    height: 142px;
}

.foot .el-table__body .el-table__row:nth-child(2) .bre-food {
    padding-top: 0;
    width: 102px;
    height: 164px;
}

.foot .el-table__body .el-table__row td:nth-child(7n) {
    border-right: none;
}

.foot .el-table__body tr:last-child td {
    position: relative;
    border-bottom: none;
}

.foot .el-table__body .el-table__row td {
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
}

.foot .el-table .cell .bre-food {
    padding: 0 10px;
    width: 102px;
    min-height: 70px;
    overflow: auto;
    font-size: 12px;
}

.foot .el-table .cell .bre-food span {
    /* display: block; */
    color: #04101a;
    margin-right: 8px;
}

.foot .el-table .el-table__row:nth-child(2) .bre-food span,
.foot .el-table .el-table__row:nth-child(3) .bre-food span {
    display: block;
}

.foot .food-lis .bre-food {
    width: 60px;
    height: 76px;
    font-size: 12px;
}

.foot .el-table .cell .icon {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1000;
}

.foot .el-table th,
.foot .el-table th.is-leaf {
    padding: 0;
}

.foot .el-table th > .cell {
    height: 60px;
}

.foot .time-bre {
    position: absolute;
    top: 136px;
    left: 40px;
    z-index: 999;
    display: flex;
    flex-direction: column;
}

.foot .time-bre span:first-child {
    padding: 0;
}

.foot .time-bre span {
    padding-top: 12px;
    height: 110px;
}

.foot .time-bre span:nth-child(2) {
    padding-top: 30px;
    height: 130px;
}

.bre-icon-sele {
    cursor: pointer;
    width: 100%;
    height: 100%;
}

.time-week {
    position: absolute;
    top: 90px;
    left: 74px;
    z-index: 999;
}

.time-week span {
    display: inline-block;
    width: 120px;
    text-align: center;
}

.label-calss {
    color: #333;
    text-align: center;
    font-size: 16px;
}

.label-endday {
    color: #ff6826;
    text-align: center;
    font-size: 16px;
}

/* 画餐注意事项 */
.careful {
    position: relative;
}

.careful h5 {
    font-size: 14px;
    margin-bottom: 6px;
}

.careful p {
    color: red;
    margin: 0;
    font-size: 12px;
}

.careful .last-week {
    position: absolute;
    bottom: 0;
    right: 100px;
    width: 80px;
    text-align: center;
    border-radius: 3px;
    color: #fff;
    cursor: pointer;
}

.careful .next-week {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 80px;
    text-align: center;
    border-radius: 3px;
    color: #fff;
    cursor: pointer;
}

/* 弹出书签 */
.book-mark {
    position: relative;
}

.mark-item {
    margin-bottom: 20px;
}

.mark-item .mark-top {
    margin-bottom: 10px;
}

.mark-item .el-tag {
    margin-right: 20px;
    margin-bottom: 10px;
}

.mark-item a {
    text-decoration: none;
    color: #377aff;
}

.mark-box {
    height: 350px;
    overflow: auto;
}

/* 书签输入框 */
.mark-bottom {
    width: 100%;
    height: 30px;
}

.mark-input {
    width: 378px;
    margin: 60px auto 0;
}

.mark-input input {
    width: 300px;
    height: 30px;
    padding: 0 10px;
}

.mark-input span {
    display: inline-block;
    width: 50px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    background-color: #377aff;
    color: #fff;
    margin-left: -4px;
    cursor: pointer;
}

/* 弹出消息 */
.message-dialog {
    position: relative;
}

.message-position {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    overflow: auto;
    margin-bottom: 0;
    background-color: rgba(255, 255, 255, 0.95);
}

.header-title {
    color: #04101a;
    font-size: 12px;
    text-align: left !important;
}

.time-list {
    margin-top: 20px;
    cursor: pointer;
    padding-bottom: 30px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.time-list:last-child {
    border-bottom: none;
}

.message-time {
    display: inline-block;
    margin-top: 10px;
    font-weight: bold;
    font-size: 12px;
    color: #999;
}

.message-position .el-dialog__header {
    padding: 20px 10px 0;
}

.message-position .el-dialog__body {
    padding: 0;
}

.message-position .el-tabs__header {
    margin: 0;
}

.message-position .el-dialog--center {
    text-align: left;
}

.message-item {
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #fff;
}

.message-item:first-child {
    margin-top: 0;
}

.task-people {
    margin-left: 20px;
}

.task-people p {
    margin: 0;
    padding: 0;
}

.task-people :nth-child(2) {
    font-size: 12px;
    margin-top: 4px;
    color: #ccc;
}

.detail-content {
    font-weight: bold;
    /*margin-top: 10px;*/
    margin-left: 60px;
}

.status {
    margin-left: 120px;
    color: #ff6826;
}

/* 底部格局 */
/*.d-footer {*/
/*  width: 100%;*/
/*  bottom: 0;*/
/*  position: absolute;*/
/*  !*display: flex;*!*/
/*  flex-direction: row;*/
/*  justify-content: center;*/
/*  padding: 20px;*/
/*  box-sizing: border-box;*/
/*  align-items: flex-end;*/
/*}*/

/* 设置popver */
.f-left {
    /*position: relative;*/
    position: absolute;
    bottom: 20px;
    left: 20px;
    font-weight: 600;
    padding-right: 10px;
    /*flex: 1;*/
    z-index: 99;
    text-align: left;
}
/* 设置popver */
.f-lefts {
    /*position: relative;*/
    position: absolute;
    bottom: 20px;
    left: 120px;
    font-weight: 600;
    padding-right: 10px;
    /*flex: 1;*/
    z-index: 99;
    text-align: left;
}

.setting {
    cursor: pointer;
    padding-left: 10px;
}

.setting img {
    vertical-align: middle;
}

.setting-todo {
    font-size: 24px;
    cursor: pointer;
    padding-right: 24px;
}

.popper__arrow:after {
    left: 20px;
}

.f-left i {
    margin-right: 5px;
    font-size: 125%;
}

.f-middle {
    position: absolute;
    bottom: 20px;
    left: 20%;
    width: 60%;
    text-align: center;
    /*flex: 3;*/
    min-height: 34px;
    line-height: 34px;
    vertical-align: top;
    cursor: default;
}

/* 用户头像 */
.userInFo {
    position: absolute;
    width: 140px;
    height: 100px;
    z-index: 999;
    font-family: sans-serif;
}

.userInFo img:last-child {
    vertical-align: middle;
    cursor: pointer;
}

img {
    vertical-align: middle;
}

.userInFo .userImg {
    width: 50px;
    height: 50px;
    margin: 10px auto;
    border-radius: 50%;
    background-color: #fff;
}

.userInFo .userImg img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

.userInFo i {
    display: inline-block;
    width: 50px;
    margin-left: 40px;
}

/* 界面 */
.main-look {
    padding: 0 20px;
}

/* 公告/热点 */
.hot {
    /* position: absolute; */
    padding: 0 20px;
}

.hot-dialog .el-dialog__body {
    padding-top: 14px;
}

.hot .title {
    width: 132px;
}

.title {
    padding-top: 20px;
}

.hot-title {
    font-size: 18px;
    color: #04101a;
    font-weight: bold;
}

.hot-main {
    padding: 0 10px;
    height: 450px;
    width: 100%;
    line-height: 26px;
    text-align: left;
    overflow: auto;
}

.hot-main img {
    margin: 10px 0;
}

.title h4 {
    font-size: 16px;
    margin: 12px 0;
}

.title span {
    font-size: 12px;
}

.hot .content h5 {
    font-size: 16px;
    margin: 20px 0px;
}

.hot .content ul {
    list-style: none;
    padding: 16px 0;
    height: 270px;
    overflow: auto;
}

.hot .content ul li {
    cursor: pointer;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.hot .content .text {
    font-size: 14px;
    color: #828282;
    line-height: 24px;
}

.hot .more {
    padding-top: 20px;
    cursor: pointer;
    text-align: right;
}

/*link*/
.link-a,
.matter {
    padding: 0 20px;
}

.link-main,
.matter-switch {
    padding: 16px 0;
}

.link-main li,
.matter-switch li {
    height: 32px;
    padding-top: 14px;
    list-style: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}

.link-main li div:last-child,
.matter-switch li div:last-child {
    float: right;
}

/* 帮助 */
.help {
    padding: 0 20px;
}

.help .help-item {
    margin-top: 30px;
    height: 300px;
    overflow: auto;
}

.help .help-item div {
    cursor: pointer;
}

.help .el-collapse {
    border: none;
}

.help .el-collapse-item__header {
    background-color: transparent;
    border-bottom: none;
    color: #fff;
}

.help .el-collapse-item__wrap {
    background-color: transparent;
    border-bottom: none;
}

.help .el-collapse-item__content {
    color: rgba(255, 255, 255, 0.8);
}

/* 建议 */
.proposal {
    padding: 0 20px;
}

.proposal .text-area {
    padding-top: 16px;
}
.proposal .text-area::-webkit-input-placeholder { /* WebKit browsers */
    padding: 10px 0 0 10px;
    color: red;
}
.proposal .text-area:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    padding: 10px 0 0 10px;
    color: red;
}
.proposal .text-area::-moz-placeholder { /* Mozilla Firefox 19+ */
    padding: 10px 0 0 10px;
    color: red;
}
.proposal .text-area:-ms-input-placeholder { /* Internet Explorer 10+ */
    padding: 10px 0 0 10px;
    color: red;
}
.proposal .text-area textarea {
    resize: none;
    opacity: 0.8;
}

.proposal .btn {
    width: 100%;
    height: 100%;
}

.proposal .proposal-btn {
    display: block;
    width: 100px;
    height: 30px;
    color: #fff;
    background-color: #377aff;
    border: 1px solid transparent;
    outline: none;
    margin: 20px 0 0 344px;
    cursor: pointer;
}

.proposal-ok .proposal-icon {
    width: 100%;
    height: 30px;
}

.proposal-img img {
    display: block;
    width: 70px;
    height: 70px;
    margin: 60px auto 12px;
}

.proposal-ok p {
    text-align: center;
}

.proposal-ok p:last-child {
    color: #ff6826;
    margin-top: 20px;
    cursor: pointer;
}

/* 我们 */
.self-we {
    padding: 0 20px;
}

.self-we ul {
    list-style: none;
    padding-left: 0;
    height: 300px;
    overflow: auto;
}

.self-we .content {
    padding-top: 20px;
}

.self-we ul h5 {
    font-size: 14px;
    margin: 0 0 10px;
}

.self-we ul li {
    padding-top: 10px;
    cursor: pointer;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.self-we ul .text {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 16px;
}

/* 心灵鸡汤 */
.none {
    opacity: 0;
}

/* todo */
.f-right {
    position: absolute;
    bottom: 20px;
    right: 20px;
    font-weight: 600;
    /*flex: 1;*/
    text-align: right;
    z-index: 999;
}

/* .right-bottom {
    position: absolute;
    bottom: 40px;
    right: 0;
    padding: 10px;
    width: 320px;
    height: 380px;
    border-radius: 14px;
    background: rgba(15, 15, 15, 0.925);
} */
.right-bottom {
    position: absolute;
    text-align: left;
    bottom: 40px;
    right: 0;
    padding: 10px;
    width: 320px;
    /* max-height: 380px;
    overflow: auto; */
    border-radius: 14px;
    background: rgba(15, 15, 15, 0.925);
}

/* .right-bottom p:first-child {
    margin-top: 100px;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    opacity: 0.6;
}

.right-bottom p:nth-child(2) {
    text-align: center;
    margin: 20px 0 40px;
} */

.grant-authorization {
    display: block;
    margin: 0 auto;
    width: 100px;
    height: 40px;
    line-height: 40px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(112, 112, 112, 1);
    font-size: 14px;
    opacity: 0.8;
    border-radius: 4px;
    color: #377aff;
    text-align: center;
    cursor: pointer;
}

.f-right .el-tabs--card > .el-tabs__header {
    padding-left: 10px;
    border-bottom: none;
}

.f-right .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: none;
}

.f-right .el-tabs--card > .el-tabs__header .el-tabs__item:last-child {
    border-left: none;
}

.f-right .el-tabs--card > .el-tabs__header .el-tabs__item {
    width: 150px;
    text-align: center;
}

.f-right .el-tabs__item {
    color: rgba(255, 255, 255, 0.4);
}

.f-right .el-tabs__item:hover {
    color: #fff;
}

.f-right .el-tabs__item.is-active {
    color: #fff;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 6px;
}

.f-right .group-sele {
    margin-top: 30px;
    font-size: 14px;
    font-weight: normal;
}

.f-right .group-sele .fl,
.f-right .group-sele .fr {
    cursor: pointer;
    color: #afafaf;
}

.f-right .group-sele i {
    font-size: 20px;
    vertical-align: middle;
    color: #afafaf;
}

.el-checkbox {
    color: #fff;
}

.check-todo {
    position: relative;
    display: inline-block;
    width: 0;
    line-height: 40px;
    height: 40px;
}
.check-todo .el-checkbox__label {
    color: #fff;
}

.el-box {
    height: 270px;
    overflow: auto;
    padding-left: 12px;
}

.el-box::-webkit-scrollbar,
.help-item::-webkit-scrollbar,
.message-position::-webkit-scrollbar,
.mark-box::-webkit-scrollbar,
.hot-main::-webkit-scrollbar,
.self-we ul::-webkit-scrollbar,
.hot .content ul::-webkit-scrollbar {
    width: 4px;
    background-color: #fff;
}
.project .tree-project .el-tree::-webkit-scrollbar {
    width: 0;
    background-color: #fff;
}

/* 定义滚动条轨道 内阴影+圆角 */
.el-box::-webkit-scrollbar-track,
.help-item::-webkit-scrollbar-track,
.message-position::-webkit-scrollbar-track,
.mark-box::-webkit-scrollbar-track,
.hot-main::-webkit-scrollbar-track,
.self-we ul::-webkit-scrollbar-track,
.hot .content ul::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
    background-color: #fff;
}

/* 定义滑块 内阴影+圆角 */
.el-box::-webkit-scrollbar-thumb,
.help-item::-webkit-scrollbar-thumb,
.message-position::-webkit-scrollbar-thumb,
.mark-box::-webkit-scrollbar-thumb,
.hot-main::-webkit-scrollbar-thumb,
.self-we ul::-webkit-scrollbar-thumb,
.hot .content ul::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px #a8b1b6;
    background-color: #a8b1b6;
}

.bre-food::-webkit-scrollbar {
    width: 2px;
    background-color: #fff;
}

/*定义滚动条轨道 内阴影+圆角*/
.bre-food::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
    background-color: #fff;
}

/*定义滑块 内阴影+圆角*/
.bre-food::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px #a8b1b6;
    background-color: #a8b1b6;
}

/* todo 下的编辑删除 */
.el-box-item {
    position: relative;
    text-align: left;
}

/* 弹出热点/公告模块 */
.hot-message-main {
    overflow: auto;
    padding: 0 20px;
    background-color: #fff;
}

.hot-message-main h4 {
    display: inline-block;
    font-size: 14px;
    margin: 6px 0;
    font-weight: bold;
    color: #04101a;
}

.hot-message-main li {
    cursor: pointer;
    padding-bottom: 10px;
    height: 80px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
}

.hot-message-main .flow-style {
    width: 300px;
    height: 50px;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: rgba(0, 0, 0, 0.6);
}

.prohibit {
    cursor: not-allowed;
}

.more-new {
    margin-top: 20px;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background-color: #fff;
    color: #377aff;
    border-radius: 2px;
    text-align: center;
    cursor: pointer;
}

/* 弹出tower团队 */
.group-main {
    width: 100%;
    height: 100%;
}

.group-main .group-item {
    width: 260px;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 10px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

.group-main .group-item:hover {
    background-color: #377aff;
    color: #ffffff;
}

.Team-task .el-dialog__body {
    padding: 20px 10px 10px;
}

/*建议状态*/
.suggest-content {
    text-align: left;
}

.suggest-content div {
    margin-bottom: 10px;
}

.suggest-content span {
    font-weight: bold;
}

.sug-title {
    text-align: center;
    font-size: 16px;
}

.do-not {
    font-size: 16px;
    margin-bottom: 16px;
    font-weight: normal;
    cursor: pointer;
}

.do-not:first-child {
    margin-top: 10px;
}

.do-not:hover {
    color: rgba(255, 255, 255, 0.8);
}

.detail-task {
    display: inline-block;
    width: 80%;
    font-weight: normal;
    font-size: 14px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.5);
    padding-bottom: 6px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.check-todo-done .detail-task {
    text-decoration: line-through;
}

.detail img {
    display: block;
    width: 100%;
    height: 100%;
    margin-top: 10px;
}

.taskDetail .el-dialog__body {
    text-align: left;
}

.task-time {
    height: 20px;
    color: rgba(98, 115, 129, 1);
    border-radius: 4px;
    font-size: 14px;
    margin-bottom: 10px;
}

.taskDetail-dialog {
    background-color: rgba(245, 246, 248, 1);
}

.title-h {
    color: rgba(98, 115, 129, 1);
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
    margin-bottom: 10px;
}

.title-h span {
    font-size: 14px;
    font-weight: 400;
    color: rgba(98, 115, 129, 1);
}

.detail-style {
    width: 740px;
    background: #fff;
    padding: 10px;
}

.detail {
    padding: 10px;
    width: 740px;
    min-height: 240px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
}

.overflow-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.label-style {
    margin-top: 24px;
    display: inline-block;
    padding: 0 5px;
    height: 18px;
    background: rgba(168, 177, 182, 1);
    opacity: 1;
    border-radius: 66px;
    font-size: 10px;
    color: #fff;
    margin-right: 10px;
}

.problem-style {
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    opacity: 0.95;
}

/*建议的样式*/
.style-text {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    color: rgba(168, 177, 182, 1);
    opacity: 1;
}

.problem-style-content {
    padding: 10px 0;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
}

.problem-style-time {
    font-size: 14px;
    color: rgba(55, 122, 255, 1);
}

.problem-style-status {
    font-size: 14px;
    color: rgba(255, 104, 38, 1);
}

/*sky 新增样式*/
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    font-weight: bold;
}

.project .el-tree .el-tree-node .el-tree-node__content:hover {
    background: none;
    color: #fff;
    font-weight: 500;
}

.iconfont {
    font-size: 24px;
    vertical-align: middle;
    cursor: pointer;
}

.iconfont:hover {
    color: rgba(0, 0, 0, 0.7);
}

.prompt .selectToDo-style .el-checkbox__input.is-checked + .el-checkbox__label {
    text-decoration: line-through;
}

.messageNum {
    position: relative;
}

.messageNum-style {
    position: absolute;
    right: 20px;
    top: 15px;
    display: inline-block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-color: red;
    border-radius: 50%;
    color: #fff;
}

.normal .input-sers {
    height: 30px;
    float: left;
    position: relative;
}
.project .input-sers input {
    color: #afafaf;
    height: 30px;
    width: 180px;
    line-height: 29px;
    border-radius: 30px;
    padding: 1px 0 1px 45px;
    border: none;
    outline: none;
    background: rgba(0, 0, 0, 0.5);
}
.project .el-icon-searchs {
    position: absolute;
    z-index: 999;
    top: 0px;
    right: 0px;
    line-height: 29px;
    background-color: #409eff;
    height: 32px;
    border-radius: 30px;
    padding: 0 15px;
}
.el-popover{
    bottom: 75px;
    top:none
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue